import React, { useState } from 'react';
import InputFile from '../../../UI/Inputs/InputFile/InputFile';
import InputText from '../../../UI/Inputs/InputText/InputText';
import Modal from '../../../UI/Modal';
import { RadioInput, RadioOption } from '../../../UI/Inputs/InputRadio/RadioBtns';
import classes from "./TrainingForm.module.css";
import { useSelector } from 'react-redux';
import BtnSelect from '../../../UI/Buttons/BtnSelect';

const TrainingForm = ({ training, onSave, onClose }) => {

    const texts = useSelector(state => state.translate.texts);
    const [inputs, setInputs] = useState({
        ...training,
        fileData: {
            url: `${training.baseUrl}/${training.thumbnail}`
        }
    })

    const handleChange = (name, value) => {
        setInputs(prev => ({ ...prev, [name]: value }))
    }

    const handelSave=()=>{
        onSave(inputs);
        onClose();
    }
    
    return <Modal title={texts.guidance} onClose={onClose} dropStyle={{ width: "539px", height: "554px" }} >
        <div className={classes.TrainingForm}>
            <div className={classes.Part}>
                <InputText
                    border={true}
                    label={texts.linkToTraining}
                    name={"url"}
                    setValue={handleChange}
                    value={inputs.url} />
            </div>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.openingImage} <span className={classes.SizeText}>185px x 105px</span></div>
                <div className={classes.ImagePreview} style={{ backgroundImage: `url(${inputs.fileData.url})` }}> </div>
                <div className={classes.FileBtn}>
                    <InputFile
                        fileData={inputs.fileData}
                        name={"thubnail"}
                        setFileData={(data) => handleChange("fileData", data)}
                        showName={false}
                        text={texts.changeImage} />
                </div>
            </div>
            <div className={classes.Part}>
                <InputText
                    border={true}
                    label={texts.name}
                    name={"name"}
                    setValue={handleChange}
                    value={inputs.name} />
            </div>
            <div className={classes.Part}>
                <InputText
                    border={true}
                    label={texts.description}
                    name={"description"}
                    setValue={handleChange}
                    value={inputs.description} />
            </div>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.lang}</div>
                <RadioInput onChangeValue={handleChange} value={inputs.lang} name={"lang"} row={true}>
                    <RadioOption value={"he"}>{texts.he}</RadioOption>
                    <RadioOption value={"ar"}>{texts.ar}</RadioOption>
                    <RadioOption value={"en"}>{texts.en}</RadioOption>
                </RadioInput>
            </div>
            <div className={classes.Part}>
                <BtnSelect checked={true} onClick={handelSave} dropClass={classes.Btn} >{texts.save}</BtnSelect>
            </div>
        </div>
    </Modal>
}

export default TrainingForm;